import {ViewStream} from 'spyne';

export class SkeletonView extends ViewStream {

    constructor(props={}) {
        props.channels = [["CHANNEL_ROUTE", true]];
        super(props);
    }

    addActionListeners() {
        // return nexted array(s)
        return [
            ["CHANNEL_ROUTE_CHANGE_EVENT", "disposeViewStream"]
        ];
    }

    broadcastEvents() {
        // return nexted array(s)
        return [];
    }

    onRendered() {

      if (this.props){
        this.props.el$.addClass('reveal');

      }

      const onRemoveIt = ()=>{
        if (this.props){
          this.props.el$.removeClass('reveal');

        }
      }
       window.setTimeout(onRemoveIt, 410);


    }

}

